/**
 * Facebook's Graph API cannot attach video children to organic feed
 * carousels, so video carousels publish to Instagram only. Single-video
 * posts publish to Facebook fine.
 *
 * Only standard feed posts can be carousels. Reels carry a cover image as
 * a second media item (video + thumbnail) and stories are single-frame, so
 * neither is a carousel even though they trip the length + video heuristic.
 */

import type { Post } from "@/core/types/postTypes";

export function isVideoCarousel(
  post: Pick<Post, "mediaItems"> & { postType?: Post["postType"] }
): boolean {
  if (post.postType === "reel" || post.postType === "story") return false;
  const items = post.mediaItems ?? [];
  return items.length >= 2 && items.some((item) => item.mediaType === "video");
}
